module.exports = __webpack_public_path__ + "img/ic-open.213a37e5.svg";